(() => {
  'use strict';

  const root = document.querySelector('[data-blog-listing]');
  if (!root) return;

  const chips = [...root.querySelectorAll('[data-blog-filter]')];
  const cards = [...root.querySelectorAll('[data-blog-card]')];
  const featured = root.querySelector('[data-blog-featured]');
  const countEl = root.querySelector('[data-blog-count]');
  const emptyEl = root.querySelector('[data-blog-empty]');
  const resetBtn = root.querySelector('[data-blog-reset]');

  const labels = {
    one: root.dataset.countOne || '__count__ guide',
    other: root.dataset.countOther || '__count__ guides',
  };

  const setActive = (key) => {
    chips.forEach((chip) => {
      const active = chip.dataset.blogFilter === key;
      chip.toggleAttribute('aria-pressed', active);
      chip.classList.toggle('is-active', active);
    });
  };

  const updateCount = (n) => {
    if (!countEl) return;
    const template = n === 1 ? labels.one : labels.other;
    countEl.textContent = template.replace('__count__', String(n));
  };

  const filter = (key) => {
    setActive(key);

    let visible = 0;
    cards.forEach((card) => {
      const match = key === 'tous' || card.dataset.cat === key;
      card.hidden = !match;
      if (match) visible += 1;
    });

    if (featured) {
      const showFeatured = key === 'tous';
      featured.hidden = !showFeatured;
      if (showFeatured) visible += 1;
    }

    if (emptyEl) emptyEl.hidden = visible > 0;
    updateCount(visible);
  };

  chips.forEach((chip) => {
    chip.addEventListener('click', () => filter(chip.dataset.blogFilter || 'tous'));
  });

  resetBtn?.addEventListener('click', () => filter('tous'));

  filter('tous');
})();
